import React, { useState, useEffect } from 'react';
import SimpleAlert from '../components/SimpleAlert';

export default function AdminOrderList({ onEdit, onDetail }) {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [keyword, setKeyword] = useState('');
  const [alert, setAlert] = useState({ open: false, message: '' });
  const [loading, setLoading] = useState(false);
  const [pageInput, setPageInput] = useState('');

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('adminToken');
      const res = await fetch(`/api/admin/orders?keyword=${keyword}`, {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (res.status === 401 || res.status === 403) {
        setAlert({ open: true, message: '您没有权限执行此操作' });
        return;
      }
      const data = await res.json();
      setOrders(Array.isArray(data) ? data : []);
      setCurrentPage(1); 
    } catch (e) {
      setAlert({ open: true, message: '请求失败，请稍后重试' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrders(); }, [keyword]);

  // 计算分页数据
  const totalPages = Math.ceil(orders.length / pageSize) || 1;
  const pagedOrders = orders.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div style={{
      padding: 'clamp(16px, 4vw, 24px)',
      maxWidth: '100%',
      overflow: 'hidden'
    }}>
      <h2 style={{
        marginBottom: 'clamp(12px, 3vw, 16px)',
        fontSize: 'clamp(18px, 4vw, 24px)'
      }}>订单查询</h2>
      <div style={{
        display: 'flex',
        gap: 'clamp(8px, 2vw, 12px)',
        marginBottom: 'clamp(12px, 3vw, 16px)',
        flexWrap: 'wrap',
        alignItems: 'center'
      }}>
        <input
          value={keyword}
          onChange={e => setKeyword(e.target.value)}
          placeholder="业务流水号/机构名称/统一社会信用代码"
          className="input"
          style={{
            flex: '1',
            minWidth: '200px',
            fontSize: 'clamp(14px, 3vw, 16px)',
            padding: 'clamp(8px, 2vw, 12px)'
          }}
        />
        <button
          onClick={fetchOrders}
          disabled={loading}
          style={{
            fontSize: 'clamp(11px, 2.5vw, 13px)',
            padding: 'clamp(6px, 1.5vw, 8px) clamp(12px, 2.5vw, 16px)',
            whiteSpace: 'nowrap',
            background: loading ? '#6c757d' : '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease',
            fontWeight: '500',
            minWidth: 'fit-content'
          }}
          onMouseOver={(e) => {
            if (!loading) {
              e.target.style.background = '#0056b3';
              e.target.style.transform = 'translateY(-1px)';
            }
          }}
          onMouseOut={(e) => {
            if (!loading) {
              e.target.style.background = '#007bff';
              e.target.style.transform = 'translateY(0)';
            }
          }}
        >{loading ? '查询中...' : '查询'}</button>
        <button
          onClick={() => onEdit(null)}
          style={{
            fontSize: 'clamp(11px, 2.5vw, 13px)',
            padding: 'clamp(6px, 1.5vw, 8px) clamp(12px, 2.5vw, 16px)',
            whiteSpace: 'nowrap',
            background: '#28a745',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            fontWeight: '500',
            minWidth: 'fit-content'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#1e7e34';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#28a745';
            e.target.style.transform = 'translateY(0)';
          }}
        >新建订单</button>
      </div>
      <div style={{
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch'
      }}>
        <table style={{
          width: '100%',
          minWidth: '600px',
          background: '#fff',
          borderCollapse: 'collapse',
          borderRadius: 'var(--border-radius)',
          overflow: 'hidden',
          boxShadow: 'var(--box-shadow)',
          fontSize: 'clamp(12px, 3vw, 14px)'
        }}>
          <thead style={{background: 'var(--bg-color)'}}>
            <tr>
              <th>#</th>
              <th>业务流水号</th>
              <th>机构名称</th>
              <th>状态</th>
              <th>创建人</th>
              <th>最后修改人</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {pagedOrders.map((order, idx) => (
              <tr key={order.id}>
                <td>{(currentPage - 1) * pageSize + idx + 1}</td>
                <td>{order.flow_no}</td>
                <td style={{maxWidth:'200px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}} title={order.name}>{order.name}</td>
                <td>{order.status}</td>
                <td>{order.create_name}</td>
                <td>{order.update_name}</td>
                <td style={{ padding: '12px 16px' }}>
                  <div style={{
                    display: 'flex',
                    gap: 'clamp(4px, 1vw, 8px)',
                    flexWrap: 'wrap'
                  }}>
                    <button
                      onClick={() => onDetail(order.id)}
                      style={{
                        padding: 'clamp(4px, 1vw, 6px) clamp(8px, 2vw, 12px)',
                        fontSize: 'clamp(11px, 2.5vw, 12px)',
                        borderRadius: '4px',
                        border: '1px solid #007bff',
                        background: '#007bff',
                        color: '#fff',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        whiteSpace: 'nowrap'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = '#0056b3';
                        e.target.style.borderColor = '#0056b3';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = '#007bff';
                        e.target.style.borderColor = '#007bff';
                      }}
                    >
                      详情
                    </button>
                  {order.status !== '已结单' && (
                    <>
                        <button
                          onClick={() => onEdit(order.id)}
                          style={{
                            padding: 'clamp(4px, 1vw, 6px) clamp(8px, 2vw, 12px)',
                            fontSize: 'clamp(11px, 2.5vw, 12px)',
                            borderRadius: '4px',
                            border: '1px solid #28a745',
                            background: '#28a745',
                            color: '#fff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            whiteSpace: 'nowrap'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.background = '#1e7e34';
                            e.target.style.borderColor = '#1e7e34';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.background = '#28a745';
                            e.target.style.borderColor = '#28a745';
                          }}
                        >
                          编辑
                        </button>
                        <button
                          onClick={async () => {
                        if (window.confirm('确定删除？')) {
                          const token = localStorage.getItem('adminToken');
                          const res = await fetch(`/api/admin/order/${order.id}`, {
                            method: 'DELETE',
                            headers: { Authorization: 'Bearer ' + token }
                          });
                          if (res.status === 401 || res.status === 403) {
                            setAlert({ open: true, message: '您没有权限执行此操作' });
                            return;
                          }
                          fetchOrders();
                        }
                          }}
                          style={{
                            padding: '6px 12px',
                            fontSize: '12px',
                            borderRadius: '4px',
                            border: '1px solid #dc3545',
                            background: '#dc3545',
                            color: '#fff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.background = '#c82333';
                            e.target.style.borderColor = '#c82333';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.background = '#dc3545';
                            e.target.style.borderColor = '#dc3545';
                          }}
                        >
                          删除
                        </button>
                    </>
                  )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <SimpleAlert open={alert.open} message={alert.message} onClose={() => setAlert({ ...alert, open: false })} />

      {/* 分页控件 */}
      {totalPages > 1 && (
       <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16, gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
    {/* 上一页按钮 */}
    <button
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
      style={{ padding: '6px 12px', fontSize: 12, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
    >上一页</button>

    {/* 首页 */}
    {currentPage > 3 && (
      <button
        key={1}
        onClick={() => setCurrentPage(1)}
        style={{
          padding: '6px 12px',
          fontSize: 12,
          fontWeight: 1 === currentPage ? 'bold' : 'normal',
          background: 1 === currentPage ? '#007bff' : '#fff',
          color: 1 === currentPage ? '#fff' : '#000',
          border: '1px solid #ccc',
          cursor: 'pointer'
        }}
      >1</button>
    )}

    {/* 前省略号 */}
    {currentPage > 4 && (
      <span style={{ padding: '6px 12px', fontSize: 12, color: '#666', cursor: 'default' }}>...</span>
    )}

    {/* 中间页码 */}
    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
      let page;
      if (currentPage <= 3) {
        page = i + 1;
      } else if (currentPage >= totalPages - 2) {
        page = totalPages - 4 + i;
      } else {
        page = currentPage - 2 + i;
      }
      return page;
    }).filter(page => page >= 1 && page <= totalPages).map(page => (
      <button
        key={page}
        onClick={() => setCurrentPage(page)}
        style={{
          padding: '6px 12px',
          fontSize: 12,
          fontWeight: page === currentPage ? 'bold' : 'normal',
          background: page === currentPage ? '#007bff' : '#fff',
          color: page === currentPage ? '#fff' : '#000',
          border: '1px solid #ccc',
          cursor: 'pointer'
        }}
      >{page}</button>
    ))}

    {/* 后省略号 */}
    {currentPage < totalPages - 3 && (
      <span style={{ padding: '6px 12px', fontSize: 12, color: '#666', cursor: 'default' }}>...</span>
    )}

    {/* 末页 */}
    {currentPage < totalPages - 2 && totalPages > 1 && (
      <button
        key={totalPages}
        onClick={() => setCurrentPage(totalPages)}
        style={{
          padding: '6px 12px',
          fontSize: 12,
          fontWeight: totalPages === currentPage ? 'bold' : 'normal',
          background: totalPages === currentPage ? '#007bff' : '#fff',
          color: totalPages === currentPage ? '#fff' : '#000',
          border: '1px solid #ccc',
          cursor: 'pointer'
        }}
      >{totalPages}</button>
    )}

    {/* 下一页按钮 */}
    <button
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
      style={{ padding: '6px 12px', fontSize: 12, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
    >下一页</button>

    {/* 页码跳转 */}
    <span style={{ fontSize: 12 }}>跳转到第:</span>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16, gap: 8, flexWrap: 'wrap', alignItems:'center' }}>
    <input 
      type="number" 
      min="1" 
      max={totalPages} 
      value={pageInput || ''} 
      onChange={e => setPageInput(e.target.value)} 
      style={{ width: 70, fontSize: 12, padding: '6px 6px' }} 
    />
    </div>
    <span style={{ fontSize: 12 }}>页</span>
    <button 
      onClick={() => {
        const p = Number(pageInput);
        if (p >= 1 && p <= totalPages) setCurrentPage(p);
      }} 
      style={{ padding: '6px 12px', fontSize: 12 }} 
    >跳转</button>
  </div>
)}
    </div>
  );
}
